import { render, staticRenderFns } from "./ReservationsRecommendCoachPop.vue?vue&type=template&id=5fded9b0&scoped=true&"
import script from "./ReservationsRecommendCoachPop.vue?vue&type=script&lang=js&"
export * from "./ReservationsRecommendCoachPop.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsRecommendCoachPop.vue?vue&type=style&index=0&id=5fded9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fded9b0",
  null
  
)

export default component.exports